export const getInitials = (name?: string | null): string => {
  if (!name || typeof name !== 'string') return "U"; // Fallback initial for unknown users

  const trimmedName = name.trim();
  if (!trimmedName) return "U"; // Handle empty string after trim

  const nameParts = trimmedName.split(" ").filter(part => part.length > 0);
  if (nameParts.length === 0) return "U";

  const firstInitial = nameParts[0][0];
  if (nameParts.length === 1) {
    return firstInitial?.toUpperCase() ?? "U";
  }

  const secondInitial = nameParts[1]?.[0] ?? "";
  return (firstInitial + secondInitial).toUpperCase();
};
